import { baseAPIRequest } from 'utilities/http';

import { baseURI } from './config';

async function postQuestion (questionPayload) {

	try {

		const url = `${baseURI}/questions`;
		const response = await baseAPIRequest({
			url,
			data: questionPayload,
			params: {
				method: 'POST'
			}
		});

		if (!response.isSuccess) {

			const [ error ] = response.errors;
			throw new Error(`Failed to create question: ${error.message}`);

		}

		return response.result;

	} catch (error) {

		/* eslint-disable no-console */
		console.error(error.message);
		throw Error;

	}

}

export default postQuestion;
